export default class Result {
  constructor(
    public readonly mayShow: boolean,
    public readonly reason?: Reason,
    public readonly error?: Error
  ) {}
}

export enum Reason {
  Error = 'An error occurred',
  ModalOpen = 'Modal is open',
  ShownRecently = 'A nudge was shown recently',
  NudgeShownRecently = 'This nudge was shown recently'
}
